export default (num, digits) => {
  let si = [
    { value: 1, symbol: "" },
    { value: 1E3, symbol: "k" },
    { value: 1E6, symbol: "M" },
    { value: 1E9, symbol: "MM" },
    { value: 1E12, symbol: "T" },
    { value: 1E15, symbol: "P" },
    { value: 1E18, symbol: "E" }
  ];
  let rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  let i;
  let flagNegative = false;
  for (i = si.length - 1; i > 0; i--) {
    if (num < 0 ) {
      flagNegative = true;
      num = num * -1;
    }
    if (num >= si[i].value) {
      break;
    }
  }
  let value = (Math.abs(num) / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
  if (flagNegative) value = "-" + value;
  return "$ " + value;
}